import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-filters-sidebar',
  templateUrl: './filters-sidebar.component.html',
  styleUrls: ['./filters-sidebar.component.scss'],
  standalone: false,
})
export class FiltersSidebarComponent implements OnInit {

  // Inouts
  @Input("show") show: boolean = false;
  @Input("canFilter") canFilter: boolean = true;
  // Outputs
  @Output("onApply") onApply: EventEmitter<string> = new EventEmitter();
  @Output("onReset") onReset: EventEmitter<void> = new EventEmitter();
  @Output("onClose") onClose: EventEmitter<void> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  applyOnAction() {
    this.onApply.emit();
    this.hideOnAction();
  }

  resetOnAction() {
    this.onReset.emit();
    this.hideOnAction();
  }

  hideOnAction() {
    this.show = false;
    this.onClose.emit();
  }

}
